import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Navigation, Search, ArrowLeft } from 'lucide-react';
export function LocationSetupScreen() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1009">
      <div className="pt-12 px-6 pb-4" data-id="element-1010">
        <button onClick={() => navigate(-1)} className="mb-6 p-2 -ml-2 rounded-full hover:bg-ui-card active:bg-ui-border transition-colors" data-id="element-1011">
          <ArrowLeft size={24} className="text-text-main" data-id="element-1012" />
        </button>
      </div>

      <div className="flex-1 flex flex-col px-6" data-id="element-1013">
        <div className="flex justify-center mb-8" data-id="element-1014">
          <div className="w-32 h-32 bg-brand-light rounded-full flex items-center justify-center relative" data-id="element-1015">
            <MapPin size={48} className="text-brand-primary relative z-10" data-id="element-1016" />
            <div className="absolute inset-0 bg-brand-primary/10 rounded-full animate-ping" data-id="element-1017"></div>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-text-main text-center mb-3" data-id="element-1018">
          Where are you?
        </h1>
        <p className="text-text-secondary text-center mb-10 px-4" data-id="element-1019">
          Enable location to find the best doctors, nurses, and clinics near
          you.
        </p>

        <button onClick={() => navigate('/needs-today')} className="w-full bg-brand-primary text-white font-semibold text-lg py-4 rounded-xl shadow-md active:scale-[0.98] transition-transform flex items-center justify-center mb-6" data-id="element-1020">
          <Navigation size={20} className="mr-2" data-id="element-1021" />
          Use Current Location
        </button>

        <div className="relative mb-6" data-id="element-1022">
          <div className="absolute inset-0 flex items-center" data-id="element-1023">
            <div className="w-full border-t border-ui-border" data-id="element-1024"></div>
          </div>
          <div className="relative flex justify-center text-sm" data-id="element-1025">
            <span className="px-2 bg-ui-bg text-text-secondary" data-id="element-1026">
              Or enter manually
            </span>
          </div>
        </div>

        <div className="space-y-4" data-id="element-1027">
          <div className="relative" data-id="element-1028">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1029">
              <Search size={18} className="text-text-secondary" data-id="element-1030" />
            </div>
            <input type="text" placeholder="Enter city or area (e.g. Lekki, Lagos)" className="w-full pl-10 pr-4 py-4 bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" data-id="element-1031" />
          </div>
          <button onClick={() => navigate('/needs-today')} className="w-full bg-white text-text-main border border-ui-border font-semibold text-lg py-4 rounded-xl shadow-sm active:bg-gray-50 transition-colors" data-id="element-1032">
            Confirm Location
          </button>
        </div>
      </div>
    </div>;
}